import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/integration/apiKeys/editApiKeyContainer';
import { actions } from '../../../redux/integration/apiKeys';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
